import { useEffect } from 'react'

const useOnTabFocus = (callback: () => void) => {
    useEffect(() => {
        const handleFocus = () => {
            callback()
        }

        window.addEventListener('focus', handleFocus)
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                callback()
            }
        })

        return () => {
            window.removeEventListener('focus', handleFocus)
            document.removeEventListener('visibilitychange', handleFocus)
        }
    }, [callback])
}

export default useOnTabFocus
